//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';

export const getLike2BuyV2Insights = createSelector(
  (state: ICuralateStore) => state.insights,
  (insights) => insights.like2BuyV2,
);
